import { IPaths } from "~/types/routing";

const PRODUCT_DROPS_BASE = "/product-drops";

export const paths: IPaths = {
  myDropsRoot: `${PRODUCT_DROPS_BASE}/my-drops`,
  myDropsProductsList: `${PRODUCT_DROPS_BASE}/my-drops/products/:id`,
  myDropsProductDetails: `${PRODUCT_DROPS_BASE}/my-drops/products/:id/product/:productId`,
  savedListsRoot: `${PRODUCT_DROPS_BASE}/saved-lists`,
  savedListsPreview: `${PRODUCT_DROPS_BASE}/saved-lists/:listId`,
};
